import { API } from "@/lib/api";
import { Download } from "lucide-react";

const SECTIONS = [
  { t: "Brand Story", d: "Hope & Favor was born from a belief that a thoughtful gesture, sent at the right moment, can carry someone through their hardest season." },
  { t: "Mission & Vision", d: "To help people feel seen, encouraged, and supported through beautifully curated, heartfelt gifts — toward a world where kindness is sent freely." },
  { t: "Voice & Tone", d: "Every message sounds like a caring conversation. 'We are so grateful you are here.' — never 'BUY NOW!!'" },
  { t: "Typography", d: "Cormorant Garamond for headings, Manrope for body, Caveat for handwritten Hope Card touches." },
  { t: "Photography", d: "Soft, natural light. Calm flatlays in sage, cream, dusty rose and gold. Real moments over staged perfection." },
  { t: "Packaging", d: "shipping box, ribbon, gold seal, tissue paper, Hope Card, and branded sticker. Everything intentional." },
  { t: "Customer Experience", d: "We treat every order like we're sending it to a dear friend. Warmth, never pressure. Kindness over extravagance, always." },
  { t: "Future Roadmap", d: "Seasonal care packages, corporate gifts, wedding party gifts, teacher gifts, holiday collections, and monthly subscription boxes." },
];

const PALETTE = [
  { n: "Sage Green", h: "#8E9A86" }, { n: "Warm Cream", h: "#FAF7F2" },
  { n: "Soft Gold", h: "#D9CBA0" }, { n: "Dusty Rose", h: "#C4A4A4" },
  { n: "Warm Taupe", h: "#8A8175" }, { n: "Espresso", h: "#3A3632" },
];

export default function BrandBible() {
  return (
    <div className="max-w-5xl mx-auto px-5 sm:px-8 py-16">
      <div className="text-center max-w-2xl mx-auto">
        <span className="text-xs tracking-[0.25em] uppercase text-[#8A8175] font-semibold">The Foundation</span>
        <h1 className="font-heading text-5xl sm:text-6xl text-[#3A3632] mt-3">Brand Bible</h1>
        <p className="text-lg text-[#6B655F] mt-4 leading-relaxed">The heart and guidelines of Hope &amp; Favor — to keep everything consistent and warm as we grow.</p>
        <a href={`${API}/brand-bible/download`} data-testid="brand-bible-download" className="inline-flex items-center gap-2 mt-7 bg-[#8E9A86] text-white rounded-full px-8 py-3.5 font-medium hover:bg-[#7A8772] transition-colors">
          <Download className="h-4 w-4" /> Download the document
        </a>
      </div>

      <div className="mt-14">
        <h2 className="font-heading text-3xl text-[#3A3632] mb-5">Color Palette</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {PALETTE.map((c) => (
            <div key={c.n} className="rounded-xl border border-[#E5DFD5] overflow-hidden bg-white">
              <div className="h-24" style={{ background: c.h }} />
              <div className="p-4"><div className="font-medium text-[#3A3632]">{c.n}</div><div className="text-sm text-[#8A8175]">{c.h}</div></div>
            </div>
          ))}
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-5 mt-14">
        {SECTIONS.map((s, i) => (
          <div key={s.t} className="bg-white rounded-xl border border-[#E5DFD5] p-7 gh-fade-up" style={{ animationDelay: `${i * 40}ms` }}>
            <h3 className="font-heading text-2xl text-[#3A3632]">{s.t}</h3>
            <p className="text-[#6B655F] mt-2 leading-relaxed">{s.d}</p>
          </div>
        ))}
      </div>

      <div className="bg-[#3A3632] rounded-2xl p-10 mt-14 text-center">
        <p className="font-hand text-3xl sm:text-4xl text-[#D9CBA0] leading-relaxed max-w-xl mx-auto">Today... take one deep breath. Give yourself grace. Remember that you are loved.</p>
      </div>
    </div>
  );
}
